import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
    selector: 'app-table-day-out-days',
    templateUrl: './table-day-out-days.component.html',
    styleUrls: ['./table-day-out-days.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableDayOutDaysComponent implements OnInit {

	@Input() projectId: string;
	@Input() titleDescription: string;
	@Input() dayOufDays: any[] = [];
	@Input() widthDescription: number = 30;
	@Input() pagination: boolean = true;
	@Input() titleSize: number = 18;
	@Input() mb: boolean = false;
	@Input() showWorkDetails: boolean = false;

	loading: boolean = true;
	weeks: any[] = [];
	sliceSize: number = 20;
	sliceStart: number = 0;
	weeksToShow: number = 5;

	graphsFullScreen = {
		'days_out': false
	}

	parseWeeks() {
		this.weeks = [];
		if (!this.dayOufDays.length || !this.dayOufDays[0].project_weeks.length) return;

		this.weeks = JSON.parse(JSON.stringify(this.dayOufDays[0].project_weeks));
		this.weeks.map(week => {
			week.days.map((day, index) => {
				delete day.day_work;
				const DAY_DATE = this._gS.getValidDateTimezone(day.date);
				day.showMonth = this._gS.isLastDayOfMonth(DAY_DATE) || this._gS.isFirstDayOfMonth(DAY_DATE);
				day.firstDay = index == 0;
			})
		});
	}

	toggleFix() {
		this.loading = true;
		setTimeout(() => {
			this.loading = false
			this._cD.detectChanges();
		}, 0);
	}

	adjustChapters() {
		this.dayOufDays.map(ch => {
			ch.merge_days = this.weeks.map(w => w.days).reduce((acc, item) => {
				acc.push(...item)
				return acc;
			}, []);
		});
	}

	trackByDay(index, item) {
		return item.date;
	}

	changePagPosition(ev, emit = true) {
		if (ev == 'next') {
			this.sliceStart = this.sliceStart + this.sliceSize
		} else if (ev == 'previous') {
			this.sliceStart = this.sliceStart - this.sliceSize
		} else if (ev == 'first') {
			this.sliceStart = 0
		} else if (ev == 'last') {
			this.sliceStart = Math.floor(this.dayOufDays.length / this.sliceSize) * this.sliceSize
		}
	}

	onScroll(ev) {
		this.weeksToShow += 10;
	}

	constructor(
		public _gS: GlobalService,
		private _cD: ChangeDetectorRef
	) { }

	ngOnInit(): void {

	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.dayOufDays) {
			this.parseWeeks();
			this.adjustChapters();
		}
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.loading = false;
			this._cD.detectChanges();
		})
	}

}
